import React from "react";
import "./CardLayout.css";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";

const cards = [
  {
    id: 1,
    title: "Reserve Fund Disclosures",
    rating: 4,
    status: "compliant",
    content: "Fully aligned with FS 730.303",
  },
  {
    id: 2,
    title: "Election Procedures",
    rating: 3,
    status: "needs-review",
    content: "Missing tie-breaker language",
  },
  {
    id: 3,
    title: "Leasing & Transfer Restrictions",
    rating: 1,
    status: "non-compliant",
    content: "Conflicts with Fair/Housing",
  },
  {
    id: 4,
    title: "Document Versioning & Execution Dates",
    rating: 5,
    status: "compliant",
    content: "",
  },
  {
    id: 5,
    title: "Budget & Financial Transparency",
    rating: 5,
    status: "compliant",
    content: "",
  },
  {
    id: 6,
    title: "Enforcement & Fine Procedures",
    rating: 3,
    status: "compliant",
    content: "Includes milestone reporting",
  },
];

const renderStars = (rating) => {
  return [...Array(5)].map((_, index) => (
    <span key={`star-${rating}-${index}`}>
      {index < rating ? (
        <StarRoundedIcon className="filled-star" sx={{ color: "#ffc107" }} />
      ) : (
        <StarOutlineRoundedIcon
          className="empty-star"
          sx={{ color: "#ababab" }}
        />
      )}
    </span>
  ));
};

const capitalizeStatus = (status) => {
  return status.charAt(0).toUpperCase() + status.slice(1);
};

const STATUS_ICONS = {
  "non-compliant": <CancelRoundedIcon color="error" />,
  compliant: <CheckCircleRoundedIcon color="success" />,
  "needs-review": <ErrorRoundedIcon color="warning" />,
};

export default function CardLayout() {
  return (
    <>
      <h3 className="px-3 pt-3">Ratings Breakdown</h3>
      <div className="rating-grid-container">
        {cards.map((card) => (
          <div key={card.id} className="rating-card">
            <h5>{card.title}</h5>
            <div className="star-rating">{renderStars(card.rating)}</div>
            <div className="d-flex align-items-center gap-1">
              {STATUS_ICONS[card.status]}
              {capitalizeStatus(card.status)}
            </div>
            <p>{card.content}</p>
          </div>
        ))}
      </div>
    </>
  );
}
